module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "SOM",
    attrs: {
      "epub:type": "toc",
      "role": "doc-toc"
    }
  }, [_c('h1', {
    staticClass: "SOM_titre",
    attrs: {
      "epub:type": "title"
    }
  }, [_vm._v("Contents")]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pre"
  }, [_c('a', {
    attrs: {
      "href": "#/pre2"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pre"
  }, [_c('a', {
    attrs: {
      "href": "#/pre3"
    }
  }, [_vm._v("Introduction: Why a Pentecostal Guide to the Holy Spirit?")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('a', {
    attrs: {
      "href": "#/chap1"
    }
  }, [_c('span', {
    staticClass: "mev1"
  }, [_vm._v("1")]), _vm._v(" The Holy Spirit in Matthew"), _c('br'), _c('span', {
    staticClass: "mev2"
  }, [_vm._v("\n    HALLMARK OF THE KINGDOM")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('a', {
    attrs: {
      "href": "#/chap2"
    }
  }, [_c('span', {
    staticClass: "mev1"
  }, [_vm._v("2")]), _vm._v(" The Holy Spirit in Mark"), _c('br'), _c('span', {
    staticClass: "mev2"
  }, [_vm._v("\n    AUTHORITY AND OBEDIENCE")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('a', {
    attrs: {
      "href": "#/chap3"
    }
  }, [_c('span', {
    staticClass: "mev1"
  }, [_vm._v("3")]), _vm._v(" The Holy Spirit in Luke"), _c('br'), _c('span', {
    staticClass: "mev2"
  }, [_vm._v("\n    GOOD NEWS FOR THE POOR AND FREEDOM FOR THE CAPTIVES")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "mev1"
  }, [_vm._v("4")]), _vm._v(" The Holy Spirit in John"), _c('br'), _c('span', {
    staticClass: "mev2"
  }, [_vm._v("\n    THE SPIRIT OF TRUTH")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "mev1"
  }, [_vm._v("5")]), _vm._v(" The Holy Spirit in Acts"), _c('br'), _c('span', {
    staticClass: "mev2"
  }, [_vm._v("\n    A PROMISE KEPT")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "mev1"
  }, [_vm._v("6")]), _vm._v(" The Holy Spirit in Romans"), _c('br'), _c('span', {
    staticClass: "mev2"
  }, [_vm._v("\n    THE SPIRIT OF ADOPTION")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "mev1"
  }, [_vm._v("7")]), _vm._v(" The Holy Spirit in 1 Corinthians"), _c('br'), _c('span', {
    staticClass: "mev2"
  }, [_vm._v("\n    THE SPIRIT OF WISDOM AND GRACE")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "mev1"
  }, [_vm._v("8")]), _vm._v(" The Holy Spirit in 2 Corinthians"), _c('br'), _c('span', {
    staticClass: "mev2"
  }, [_vm._v("\n    THE SPIRIT OF THE NEW COVENANT")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "mev1"
  }, [_vm._v("9")]), _vm._v(" The Holy Spirit in Galatians"), _c('br'), _c('span', {
    staticClass: "mev2"
  }, [_vm._v("\n    THE SPIRIT OF FREEDOM")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "mev1"
  }, [_vm._v("10")]), _vm._v(" The Holy Spirit in Ephesians, Colossians, and Philemon"), _c('br'), _c('span', {
    staticClass: "mev2"
  }, [_vm._v("\n    THE SPIRIT OF WISDOM AND REVELATION")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "mev1"
  }, [_vm._v("11")]), _vm._v(" The Holy Spirit in Philippians"), _c('br'), _c('span', {
    staticClass: "mev2"
  }, [_vm._v("\n    THE SPIRIT OF JOY ")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "mev1"
  }, [_vm._v("12")]), _vm._v(" The Holy Spirit in 1 and 2 Thessalonians"), _c('br'), _c('span', {
    staticClass: "mev2"
  }, [_vm._v("\n    ESCHATOLOGY AND ETHICS")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "mev1"
  }, [_vm._v("13")]), _vm._v(" The Holy Spirit in the Pastoral Epistles"), _c('br'), _c('span', {
    staticClass: "mev2"
  }, [_vm._v("\n    THE SPIRIT OF POWER, LOVE, AND SELF-CONTROL")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "mev1"
  }, [_vm._v("14")]), _vm._v(" The Holy Spirit in Hebrews"), _c('br'), _c('span', {
    staticClass: "mev2"
  }, [_vm._v("\n    THE TESTIMONY OF THE SPIRIT")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap15",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "mev1"
  }, [_vm._v("15")]), _vm._v(" The Holy Spirit in James"), _c('br'), _c('span', {
    staticClass: "mev2"
  }, [_vm._v("\n    THE WISDOM OF GOD ")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap16",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "mev1"
  }, [_vm._v("16")]), _vm._v(" The Holy Spirit in 1 and 2 Peter"), _c('br'), _c('span', {
    staticClass: "mev2"
  }, [_vm._v("\n    GOD'S ANSWER TO SUFFERING FOR CHRIST")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap17",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "mev1"
  }, [_vm._v("17")]), _vm._v(" The Holy Spirit in the Johannine Epistles"), _c('br'), _c('span', {
    staticClass: "mev2"
  }, [_vm._v("\n    THE SPIRIT OF LIGHT AND LOVE")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap18",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "mev1"
  }, [_vm._v("18")]), _vm._v(" The Holy Spirit in Jude"), _c('br'), _c('span', {
    staticClass: "mev2"
  }, [_vm._v("\n    PRAYING IN THE SPIRIT")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/chap19",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "mev1"
  }, [_vm._v("19")]), _vm._v(" The Holy Spirit in Revelation"), _c('br'), _c('span', {
    staticClass: "mev2"
  }, [_vm._v("\n    THE SPIRIT OF PROPHECY")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Final Thoughts")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Scripture Index")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Praise for "), _c('i', [_vm._v("The Holy Spirit in the New Testament")])])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_appen"
  }, [_c('span', {
    attrs: {
      "href": "#/appen8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('div', {
    staticClass: "SOM_pdf"
  }, [_c('span', {
    attrs: {
      "href": "#/fin_acheve",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("More Titles from InterVarsity Press")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-029e4e6e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sommaire.vue
// module id = 63
// module chunks = 0